/*
 * Copyright (c) 2019. 42 bv (www.42.nl). All rights reserved.
 */
"use strict";

/**
 * @ngdoc function
 * @name diceApp.component:diceStatusBulkChange
 */
angular.module("diceApp").component("diceStatusBulkChange", {
  bindings: {
    type: "<",
    evaluations: "<",
    onChange: "&",
    onCancel: "&"
  },
  templateUrl: "es6/evaluations/bulk/status.bulk.change.html",
  controllerAs: "statusBulkChangeController",
  controller: function (
    Evaluation,
    StatusType,
    StatusTransition,
    $uibModal,
    message,
    descriptionFilter
  ) {
    const statusBulkChangeController = this;

    statusBulkChangeController.$onInit = function () {
      loadData();
    };

    function loadData() {
      statusBulkChangeController.loading = true;
      StatusType.query()
        .$promise.then((statuses) => {
          return _.filter(statuses, {
            evaluationType: statusBulkChangeController.type.id
          });
        })
        .then((statuses) => {
          const grouped = _.groupBy(
            statusBulkChangeController.evaluations,
            "status"
          );
          statusBulkChangeController.statuses = _(statuses)
            .map((status) => {
              const amount = (grouped[status.name] || []).length;

              return _.extend(status, {
                label: `${descriptionFilter(status.labels) || status.code} (${amount})`,
                amount
              });
            })
            .filter((status) => status.amount > 0)
            .sortBy(["evaluationType", "sequence", "id"])
            .value();

          if (statusBulkChangeController.statuses.length > 0) {
            statusBulkChangeController.statusId = _.head(
              statusBulkChangeController.statuses
            ).id;
            statusBulkChangeController.onStatus();
          }
        })
        .finally(() => {
          statusBulkChangeController.loading = false;
        });
    }

    statusBulkChangeController.onStatus = function () {
      statusBulkChangeController.status = _.find(
        statusBulkChangeController.statuses,
        {
          id: statusBulkChangeController.statusId
        }
      );

      if (angular.isDefined(statusBulkChangeController.status)) {
        StatusTransition.query({
          evaluationType: statusBulkChangeController.status.evaluationType,
          currentStatus: statusBulkChangeController.status.name
        }).$promise.then((transitions) => {
          statusBulkChangeController.transitions = transitions;
        });
      } else {
        statusBulkChangeController.transitions = [];
      }
    };

    statusBulkChangeController.submit = function () {
      const transition = _.find(statusBulkChangeController.transitions, {
        id: statusBulkChangeController.transitionId
      });

      changeStatus(transition);
    };

    function changeStatus(transition) {
      openConfirm(transition, () => {
        const evaluations = _.filter(statusBulkChangeController.evaluations, {
          status: transition.fromStatus.name
        });

        statusBulkChangeController.loading = true;
        Evaluation.bulkChangeStatus({
          evaluationIds: _.map(evaluations, "id"),
          transitionId: transition.id
        })
          .$promise.then((result) => {
            message.addInfoLabel("Message.Save.Success");
            statusBulkChangeController.onChange({ result });
          })
          .finally(() => {
            statusBulkChangeController.loading = false;
          });
      });
    }

    function openConfirm(transition, callback) {
      $uibModal.open({
        template: `
            <status-confirm-change-modal
              transition="modalController.transition"
              callback="modalController.callback"
              modal="modalController.instance">
            </status-confirm-change-modal>
          `,
        controllerAs: "modalController",
        controller: function ($uibModalInstance) {
          const modalController = this;
          modalController.transition = transition;
          modalController.callback = callback;
          modalController.instance = $uibModalInstance;
        }
      });
    }
  }
});
